import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const KO_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "본 적 없는 브리스콜라: RPG, Waifu, 그리고 AI.",
      ctaWeb: "웹에서 플레이",
      ctaAndroid: "Android 다운로드",
      version: "버전 2.3",
      badge: "✨ 새로운 던전 모드"
    },
    stats: {
      downloads: "다운로드",
      downloadsValue: ["셀 수 없어요!", "서버 가득 참", "엄청 많아요!", "9000 이상", "너무 많아서 못 세요"],
      hands: "패배한 판",
      handsValue: ["너무 많아...", "실력 문제", "렉 때문임", "아직도 우니?", "다시 해봐, 운이 좋을 거야"],
      rating: "평가",
      ratingValue: ["할머니가 인정함", "11/10 - IGN", "피자보다 낫다", "GOTY 2026", "절대적인 걸작"],
      waifus: "Waifu",
      waifusValue: ["모두 너의 것", "2D가 최고", "모두 수집해!", "메타보다 와이프", "진정한 보물"]
    },
    features: {
      title: "단순한 카드 게임 그 이상",
      items: [
        { id: "classic", title: "클래식 브리스콜라", description: "오리지널 경험, 완벽하고 깔끔합니다.", icon: "🃏" },
        { id: "roguelike", title: "로그라이크 RPG", description: "탑을 오르고, 원소의 힘을 얻고 보스를 물리치세요.", icon: "⚔️" },
        { id: "ai", title: "살아있는 AI", description: "Google Gemini 덕분에 상대방이 실시간으로 당신을 모욕하거나 칭찬합니다.", icon: "🧠" },
        { id: "gacha", title: "가챠 시스템", description: "코인을 사용하여 새로운 스킨과 희귀한 배경을 잠금 해제하세요.", icon: "💎" },
        { id: "dungeon", title: "던전 모드", description: "미친 규칙을 가진 보스와 대결하세요. 한 번 패배하면 끝입니다.", icon: "🏰" },
        { id: "puzzle", title: "퍼즐 모드", description: "특정 목표를 가진 복잡한 시나리오를 해결하세요.", icon: "🧩" }
      ]
    },
    video: { title: "게임플레이 트레일러" },
    waifus: {
      title: "파트너 선택",
      subtitle: "각 캐릭터는 독특한 성격, 더빙 및 플레이 스타일을 가지고 있습니다.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "다정함", personality: "다정하고 밝으며, 당신 곁에 있는 것을 좋아합니다." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "분석가", personality: "계산적이고 차갑습니다. 오직 논리뿐." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "츤데레", personality: "승부욕이 강하고 불같습니다. 지는 것을 싫어합니다." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "여왕", personality: "카드의 어둠의 여왕." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "가이드", personality: "믿음직한 가이드... 아마도." }
      ]
    },
    reviews: {
      title: "우리에 대해 말하는 것들 (유감스럽게도)",
      items: getCommonReviews('ko')
    },
    ctaStrip: {
      title: "필드에 나갈 준비가 되셨나요?",
      subtitle: "다른 플레이어들과 함께 오늘 모험을 시작하세요.",
      button: "지금 플레이 시작"
    },
    footer: { privacy: "개인정보", terms: "이용약관", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Waifu Briscola 개인정보 처리방침",
      lastUpdated: "최종 업데이트: 2024년 5월 25일",
      intro: "이 개인정보 처리방침은 Waifu Briscola 애플리케이션('서비스')을 사용할 때 귀하의 정보가 어떻게 관리되는지 설명합니다.",
      sections: [
        {
          title: "수집하는 정보",
          intro: "귀하의 경험을 개선하기 위해 정보를 수집할 수 있는 제3자 서비스를 사용합니다:",
          items: [
            "사용 데이터 (PostHog): 우리는 귀하가 게임과 상호 작용하는 방식에 대한 익명 또는 가명 분석 데이터를 수집합니다. 여기에는 게임 시작, 사용된 카드 및 최종 결과와 같은 이벤트가 포함됩니다. 이 데이터는 게임이 어떻게 사용되는지 이해하고 개선하는 데 도움이 됩니다. PostHog를 통해 개인 식별 정보(PII)를 수집하지 않습니다.",
            "AI 상호 작용 (Google Gemini): 귀하가 보내는 채팅 메시지와 게임 상태에 대한 정보(손에 든 카드와 테이블 위의 카드 등)는 AI의 응답과 움직임을 생성하기 위해 Google Gemini API로 전송됩니다. 이러한 상호 작용은 Google의 개인정보 처리방침의 적용을 받습니다. 우리는 귀하의 게임 상호 작용 내용 이외의 개인 정보를 Google에 전송하지 않습니다.",
          ],
        },
        {
          title: "정보 사용 방법",
          intro: "수집된 정보를 다음 용도로 사용합니다:",
          items: [
            "서비스 제공, 운영 및 유지 관리.",
            "서비스 개선, 개인화 및 확장.",
            "서비스 사용 방식 이해 및 분석.",
            "오용 방지 및 보안 보장.",
          ],
        },
        {
          title: "정보 공유",
          body: "위에서 설명한 대로 애플리케이션 운영에 필요한 제3자 서비스 제공업체(PostHog, Google)를 제외하고는 귀하의 개인 정보를 누구와도 공유하지 않습니다.",
        },
        {
          title: "데이터 보안",
          body: "귀하의 정보 보안은 우리에게 중요하지만, 인터넷을 통한 전송 방법이나 전자 저장 방법은 100% 안전하지 않다는 점을 기억하십시오.",
        },
        {
          title: "개인정보 처리방침 변경",
          body: "우리는 때때로 개인정보 처리방침을 업데이트할 수 있습니다. 변경 사항이 있는 경우 이 페이지에 새로운 개인정보 처리방침을 게시하여 알려드립니다.",
        },
        {
          title: "문의하기",
          body: "이 개인정보 처리방침에 대해 질문이 있는 경우 담당자 Mauro Mazzocchetti에게 문의할 수 있습니다.",
        },
      ],
    },
    consent: { text: "사이트 개선을 위해 쿠키와 분석 데이터를 사용합니다. 계속하면 다음에 동의하는 것입니다:", ok: "확인" },
    terms: {
      title: "Waifu Briscola 이용약관",
      lastUpdated: "최종 업데이트: 2024년 5월 25일",
      contact: "담당자: Mauro Mazzocchetti",
      intro: "Waifu Briscola에 오신 것을 환영합니다! 이 이용약관은 Waifu Briscola 애플리케이션('서비스') 사용 규칙을 설명합니다.",
      sections: [
        {
          title: "약관 동의",
          body: "이 서비스에 액세스하고 사용함으로써 귀하는 이 약관에 구속되는 데 동의합니다. 약관의 일부에 동의하지 않으면 서비스를 사용할 수 없습니다.",
        },
        {
          title: "서비스 사용",
          body: "귀하는 불법적이거나 승인되지 않은 목적으로 서비스를 사용하지 않을 것에 동의합니다. 귀하의 행동과 채팅 메시지를 포함하여 서비스를 사용하는 동안 제공하는 모든 콘텐츠에 대한 책임은 귀하에게 있습니다.",
        },
        {
          title: "AI 생성 콘텐츠",
          intro: "서비스는 인공 지능 모델(Google Gemini)을 사용하여 응답, 댓글 및 게임 움직임을 생성합니다. 귀하는 다음을 인정합니다:",
          items: [
            "AI 생성 콘텐츠는 모델에 의해 생성되며 항상 정확하거나 적절하거나 일관성이 없을 수 있습니다.",
            "우리는 AI 생성 콘텐츠에 대해 책임을 지지 않습니다.",
            "AI와의 상호 작용은 오락 목적으로만 의도되었습니다.",
          ],
        },
        {
          title: "책임 제한",
          body: "어떠한 경우에도 Mauro Mazzocchetti 또는 그 파트너는 (i) 서비스 액세스 또는 사용 또는 액세스 또는 사용 불가; (ii) 서비스에서 얻은 콘텐츠로 인해 발생하는 이익 손실, 데이터, 영업권 또는 기타 무형의 손실을 포함하되 이에 국한되지 않는 간접적, 우발적, 특별, 결과적 또는 징벌적 손해에 대해 책임을 지지 않습니다.",
        },
        {
          title: "약관 변경",
          body: "우리는 단독 재량으로 언제든지 이 약관을 수정하거나 교체할 권리를 보유합니다. 변경 사항이 있는 경우 이 페이지에 새로운 약관을 게시하여 알려드립니다.",
        },
        {
          title: "준거법",
          body: "이 약관은 법률 상충 조항에 관계없이 이탈리아 법률에 따라 규율되고 해석됩니다.",
        },
      ],
    }
};
